/* Porte e-mail du configurateur — NTech, 24/10/2026. Voir snippets/ntx-porte-configurateur.liquid.
   1. Clic sur le bouton Kickflip → si l'adresse n'est pas connue, la porte s'ouvre d'abord.
   2. Adresse envoyée à NTech OS (/api/site/prospect) → jeton `cid` mémorisé → le clic est rejoué, Kickflip s'ouvre.
   3. Après l'ajout au panier, la configuration (designId, image, produit) part vers /api/site/configuration avec le `cid`.
   On n'altère aucun nœud Kickflip : écoute en phase de capture, rien n'est wrappé. */
(function () {
  'use strict';
  var OS = 'https://app.ntechperf.com';
  var CLE = 'ntx_porte';            // {email, cid, t}
  var CLE_CFG = 'ntx_cfg_envoyees'; // designIds déjà transmis
  var SELECTEUR = 'customize-button, #kickflip-customize-button, .mczr-customize-button, [data-mczr="customize_button"]';

  /* ⭐ 28/10 — LA MESURE DU TUNNEL. En cinq jours la porte a rapporté 178 adresses, mais on
     ne savait pas combien de visiteurs la voient et repartent, ni combien ne la voient jamais
     parce qu'ils ont déjà donné leur adresse au pop-up. Un état par geste part vers NTech OS
     (/api/site/porte) : vue, email, sans_email, fermee, sautee.
     Mesure d'audience au sens de la CNIL : identifiant d'ONGLET tiré au hasard (jamais l'adresse,
     jamais l'IP), haché côté serveur, effacé avec l'onglet, aucun recoupement entre sites.
     Elle ne doit jamais retarder le visiteur : sendBeacon quand il existe, sinon fetch jeté. */
  var CLE_SID = 'ntx_sid';
  function sid() {
    try {
      var v = sessionStorage.getItem(CLE_SID);
      if (!v) {
        v = (window.crypto && crypto.randomUUID ? crypto.randomUUID().replace(/-/g, '')
          : String(Date.now()).slice(-10) + Math.random().toString(36).slice(2, 12)).slice(0, 32);
        sessionStorage.setItem(CLE_SID, v);
      }
      return v;
    } catch (e) { return null; }
  }
  function mesurer(quoi, etat, porte) {
    var s = sid(); if (!s) return;
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'ntx_porte', quoi: quoi, etat: etat }); } catch (e) {}
    var corps = JSON.stringify({ quoi: quoi, etat: etat, sid: s,
      handle: (porte && porte.dataset.handle) || null,
      locale: (porte && porte.dataset.locale) || null,
      pays: (porte && porte.dataset.pays) || null });
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(OS + '/api/site/porte', new Blob([corps], { type: 'text/plain' })); return; }
    } catch (e) {}
    try { fetch(OS + '/api/site/porte', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: corps, keepalive: true }).catch(function () {}); } catch (e) {}
  }

  function lire(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ecrire(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function etat() { return lire(CLE); }
  function frais(e, jours) { return !!(e && e.email && (Date.now() - (e.t || 0)) < jours * 864e5); }

  function init() {
    var porte = document.getElementById('ntx-porte');
    if (!porte) return;
    var jours = Number(porte.dataset.jours || 365);
    var handle = porte.dataset.handle || '';
    var form = porte.querySelector('form');
    var champEmail = form.querySelector('input[name="email"]');
    var champPrenom = form.querySelector('input[name="prenom"]');
    var champHp = form.querySelector('input[name="hp"]');
    var erreur = form.querySelector('.ntx-porte__erreur');
    var bouton = form.querySelector('.ntx-porte__bouton');
    var dejaRelais = false; try { dejaRelais = !!localStorage.getItem('bb_nt_cid'); } catch (x) {}
    var passe = frais(etat(), jours) || dejaRelais || sessionStorage.getItem('ntx_porte_sans') === '1';
    var enAttente = null;
    // La porte s'efface : il a déjà donné son adresse (porte, pop-up ou relais). Une ligne par
    // onglet, sinon chaque page produit en écrirait une — ⚠️ le « sans e-mail » de la session
    // ne compte pas ici, il a déjà son propre état.
    if (passe && sessionStorage.getItem('ntx_porte_sans') !== '1' && sessionStorage.getItem('ntx_mes_sautee') !== '1') {
      try { sessionStorage.setItem('ntx_mes_sautee', '1'); } catch (x) {}
      mesurer('porte', 'sautee', porte);
    }

    function ouvrir(cible) {
      enAttente = cible; porte.hidden = false; porte.setAttribute('aria-hidden', 'false');
      mesurer('porte', 'vue', porte);
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { (champPrenom && !champPrenom.value ? champPrenom : champEmail).focus(); }, 60);
    }
    function fermer() {
      porte.hidden = true; porte.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
    }
    function rejouer() {
      var cible = enAttente; enAttente = null;
      if (!cible) return;
      passe = true;
      // Le clic est rejoué sur le bouton Kickflip : notre écouteur le laisse passer (passe = true).
      setTimeout(function () { try { cible.click(); } catch (e) {} }, 30);
    }

    // 1. Interception en phase de capture — avant les écouteurs du composant Kickflip.
    document.addEventListener('click', function (ev) {
      if (passe) return;
      var cible = ev.target && ev.target.closest ? ev.target.closest(SELECTEUR) : null;
      if (!cible) return;
      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
      ouvrir(cible);
    }, true);

    porte.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ntx-porte-fermer]')) { mesurer('porte', 'fermee', porte); fermer(); enAttente = null; }
      if (ev.target.closest('[data-ntx-porte-sans]')) { mesurer('porte', 'sans_email', porte); sessionStorage.setItem('ntx_porte_sans', '1'); fermer(); rejouer(); }
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !porte.hidden) { mesurer('porte', 'fermee', porte); fermer(); enAttente = null; } });

    // 2. L'adresse part vers NTech OS ; le jeton `cid` revient (leurre pour une adresse déjà connue : sans effet).
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      erreur.hidden = true;
      var email = (champEmail.value || '').trim().toLowerCase();
      if (!/^[^\s@]{1,64}@[^\s@]{1,255}\.[a-z]{2,24}$/i.test(email)) { erreur.textContent = erreur.dataset.errEmail; erreur.hidden = false; champEmail.focus(); return; }
      bouton.disabled = true;
      mesurer('porte', 'email', porte);
      var corps = {
        email: email,
        prenom: champPrenom ? (champPrenom.value || '').trim().slice(0, 60) || null : null,
        source: 'porte_studio',
        handle: handle || null,
        locale: porte.dataset.locale || null,
        pays: porte.dataset.pays || null,
        hp: champHp ? champHp.value : ''
      };
      fetch(OS + '/api/site/prospect', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps), keepalive: true })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(function (d) {
          ecrire(CLE, { email: email, cid: d && d.cid ? String(d.cid) : null, t: Date.now() });
          if (d && d.cid) { try { localStorage.setItem('bb_nt_cid', String(d.cid)); } catch (x) {} }   // mémoire partagée avec le relais
          if (typeof fbq !== 'undefined') { try { fbq('track', 'Lead', { content_name: 'porte_configurateur' }); } catch (e) {} }
          bouton.disabled = false; fermer(); rejouer(); surveillerPanier();
        })
        .catch(function () {
          // NTech OS injoignable : le visiteur n'attend pas — le configurateur s'ouvre quand même.
          ecrire(CLE, { email: email, cid: null, t: Date.now() });
          bouton.disabled = false; fermer(); rejouer();
        });
    });

    // 3. Le panier composé → la configuration part vers NTech OS (une fois par designId).
    var minuteur = null, debut = 0;
    function surveillerPanier() {
      var e = etat(); if (!e || !e.cid) return;
      if (minuteur) return;
      debut = Date.now();
      minuteur = setInterval(verifierPanier, 5000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) verifierPanier(); });
    }
    function verifierPanier() {
      if (Date.now() - debut > 45 * 60000) { clearInterval(minuteur); minuteur = null; return; }
      if (document.hidden) return;
      var e = etat(); if (!e || !e.cid) return;
      fetch(porte.dataset.cart || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var faits = lire(CLE_CFG) || [];
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {}; var designId = null, image = null, h = it.handle || handle;
            Object.keys(p).forEach(function (k) {
              var kl = k.toLowerCase();
              if (kl === '_mczr_designid') designId = String(p[k]);
              if (kl === '_mczr_image') image = String(p[k]);
              if (kl === '_mczr_producthandle' && p[k]) h = String(p[k]);
            });
            if (!designId || faits.indexOf(designId) !== -1) return;
            faits.push(designId); ecrire(CLE_CFG, faits.slice(-20));
            // 26/10 — le prix de la ligne, sa devise et le taux : NTech OS pose le montant en euros dès
            // l'inscription (l'échelle d'offre s'applique à tous les paniers, dans toutes les langues) ;
            // l'identifiant produit retrouve le produit même depuis une page traduite.
            var cur = (window.Shopify && Shopify.currency) || {};
            fetch(OS + '/api/site/configuration', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
              body: JSON.stringify({ cid: e.cid, designId: designId, handle: h, image: image, titre: it.product_title || null,
                productId: it.product_id || null, prixCentimes: it.final_line_price || it.line_price || it.price || null,
                devise: cur.active || cart.currency || null, taux: cur.rate ? Number(cur.rate) : null }) }).catch(function () {});
          });
        }).catch(function () {});
    }
    // Un contact déjà connu (jeton présent) : on note la visite de la page produit, et on surveille le panier.
    var connu = etat();
    if (connu && connu.cid) {
      if (handle && sessionStorage.getItem('ntx_visite_' + handle) !== '1') {
        sessionStorage.setItem('ntx_visite_' + handle, '1');
        fetch(OS + '/api/site/visite', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify({ cid: connu.cid, handle: handle }) }).catch(function () {});
      }
      surveillerPanier();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
